import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { OrganisationRead, OrganisationsService } from 'Service'
import { FailureHandler } from 'Utils/ApiHelper'

let currentOrganisation: OrganisationRead | null = null

export const useCurrentOrganisation = () => {
  const params = useParams()

  const {
    data: organisation,
    error,
    isPending,
  } = useQuery({
    queryKey: ['OrganisationsService.organisationsRetrieve', params.organisation_uuid],
    queryFn: () =>
      OrganisationsService.organisationsRetrieve({
        organisationUuid: params.organisation_uuid,
      }),
    enabled: !!params.organisation_uuid,
  })

  return {
    organisation,
    error,
    isPending,
  }
}
